import { AspectRatios } from '@t2c/ai-video-editor';

export enum Status {
  NotStarted = 'NotStarted',
  AvatarFaceDetection = 'AvatarFaceDetection',
  AvatarVideoConvertionToMp4 = 'AvatarVideoConvertionToMp4',
  AvatarCreatingThumbnail = 'AvatarCreatingThumbnail',
  AvatarRemovingBackground = 'AvatarRemovingBackground',
  CompressingVideo = 'CompressingVideo',
  ExtractingAudio = 'ExtractingAudio',
  ExtractingCaption = 'ExtractingCaption',
  ExtractingClips = 'ExtractingClips',
  GeneratingBroll = 'GeneratingBroll',
  ApplyingAIBroll = 'ApplyingAIBroll',
  InProgress = 'InProgress',
  Success = 'Success',
  Error = 'Error',
  InQueue = 'InQueue',
}

export interface DashboardCardDataType {
  id: string;
  header: string;
  subheader: string;
  icon: string;
  link?: string;
}
export interface AiVideoModelDetails {
  durationPerModel?: number[];
  orientationPerModel?: AspectRatios[];
  resolutionPerModel?: string[];
  showUpload?: boolean;
  showTailUpload?: boolean;
  showVideo?: boolean;
  maxCharLimit?: number;
  maxImageSize?: number; // in mb
  showAudio?: boolean;
  showBodyControl?: boolean;
  showCharacter?: boolean;
  showEnhancePrompt?: boolean;
  isStartImageRequired?: boolean;
  isEndImageRequired?: boolean;
  isPremium?: boolean;
  comingSoon?: boolean;
  mutliShot?: string[];
}

export interface AiImageModelStyle {
  label: string;
  value: string;
}

export interface AiImageModelDetails {
  orientationPerModel: AspectRatios[];
  resolutionPerModel: string[];
  showUpload: boolean;
  showSecondUpload?: boolean;
  stylesPerModel: AiImageModelStyle[];
  maxCharLimit: number;
  maxImageSize?: number; // in mb
  isStartImageRequired?: boolean;
  isPremium?: boolean;
  numGenerations?: number;
}

export enum MODULE_TYPES {
  API = 'API',
}
